import React from 'react';
import { Skeleton } from 'antd';

import './PotentialManager.less';

export default function PotentialManagerSkeleton() {
  return (
    <div className="potential-manager">
      <div className="potential-manager--user">
        <Skeleton.Avatar size="large" active />
        <Skeleton.Input active style={{ display: 'block' }} />
      </div>
    </div>
  );
}
